"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceEstimateInputDtoPriceConfidenceEnum = void 0;
exports.instanceOfPriceEstimateInputDto = instanceOfPriceEstimateInputDto;
exports.PriceEstimateInputDtoFromJSON = PriceEstimateInputDtoFromJSON;
exports.PriceEstimateInputDtoFromJSONTyped = PriceEstimateInputDtoFromJSONTyped;
exports.PriceEstimateInputDtoToJSON = PriceEstimateInputDtoToJSON;
exports.PriceEstimateInputDtoToJSONTyped = PriceEstimateInputDtoToJSONTyped;
/**
 * @export
 */
exports.PriceEstimateInputDtoPriceConfidenceEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
};
/**
 * Check if a given object implements the PriceEstimateInputDto interface.
 */
function instanceOfPriceEstimateInputDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('lowerPrice' in value) || value['lowerPrice'] === undefined)
        return false;
    if (!('midPrice' in value) || value['midPrice'] === undefined)
        return false;
    if (!('upperPrice' in value) || value['upperPrice'] === undefined)
        return false;
    if (!('priceConfidence' in value) || value['priceConfidence'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function PriceEstimateInputDtoFromJSON(json) {
    return PriceEstimateInputDtoFromJSONTyped(json, false);
}
function PriceEstimateInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'lowerPrice': json['lowerPrice'],
        'midPrice': json['midPrice'],
        'upperPrice': json['upperPrice'],
        'priceConfidence': json['priceConfidence'],
        'source': json['source'],
    };
}
function PriceEstimateInputDtoToJSON(json) {
    return PriceEstimateInputDtoToJSONTyped(json, false);
}
function PriceEstimateInputDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'lowerPrice': value['lowerPrice'],
        'midPrice': value['midPrice'],
        'upperPrice': value['upperPrice'],
        'priceConfidence': value['priceConfidence'],
        'source': value['source'],
    };
}
